import axios from "axios";

type ApiErrorBody = {
  error?: string;
  message?: string;
  detail?: string;
  title?: string;
};

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const body = error.response?.data as ApiErrorBody | string | undefined;
    if (typeof body === "string" && body.trim()) {
      return body;
    }

    const message = typeof body === "object" && body
      ? body.error ?? body.message ?? body.detail ?? body.title
      : undefined;
    if (message?.trim()) {
      return message;
    }

    if (error.response?.status) {
      return `${fallback} (HTTP ${error.response.status}).`;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallback;
}
